import { render, staticRenderFns } from "./bidding_purchase_list.vue?vue&type=template&id=5c0d441d&scoped=true"
import script from "./bidding_purchase_list.vue?vue&type=script&lang=js"
export * from "./bidding_purchase_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d441d",
  null
  
)

export default component.exports